import { createFileRoute } from "@tanstack/react-router";
import { SummaryPage } from "../../../pages/summary-page/summary-page";
import { summarySearchSchemaValidator } from "../../../pages/summary-page/summary-search-params";

export const Route = createFileRoute("/_auth/_project/summary/$projectId/$subProjectId")({
  component: SummaryPage,
  validateSearch: summarySearchSchemaValidator,
});
